"use client";
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
	"5ad3feeafb8a277efa1cc3b2c9d96386Tz0xMjU2MzMsRT0xODAyNTYzMTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y",
);

export default function MuiXLicense() {
	return null;
}
